<template>
  <base-dialog
  v-model="model"
  header-bg="blue"
  :title="title ? title : getTitle">
    <text-area 
    v-model="localComment"
    :readonly="preview"/>
    <div
    v-if="!preview"
    class="d-flex justify-center my-4">
      <primary-btn
      :label="$t('save')"
      @click="tryToSave"
      color="#4285f4"
      :loading="loading"
      :disabled="loading"
      :width="100"
      :height="40"/>
    </div>
  </base-dialog>
</template>
<script>
import TextArea from '@/components/text-fields/TextArea'
import BaseDialog from '@/components/dialogs/BaseDialog'
import { execHttpRequestThrowable } from '@/services/http'
import PrimaryBtn from '@/components/btns/PrimaryBtn'
export default {
  components: {
    PrimaryBtn,
    TextArea,
    BaseDialog
  },
  props: {
    value: Boolean,
    title: String,
    comment: {
      type: String,
      default: null
    },
    ownerId: {
      type: Number,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    stepStatus: {
      type: String,
      required: true
    },
    preview: {
      type: Boolean,
      default: false
    },
    saver: {
      type: Function,
      default: null
    }
  },
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  data() {
    return {
      loading: false,
      localComment: null
    }
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit('valueChanged', v)
      }
    },
    getTitle() {
      switch (this.status) {
        case "APPROVED": return "dialogs.titles.whyApprovedPart"
        case "REJECTED": return "dialogs.titles.whyRejectedPart"
        case "REQUEST": return "dialogs.titles.requestApprovalComment"
        default: return "dialogs.titles.waitingApprovalPart"
      }
    }
  },
  methods: {
    closeDialog() {
      this.model = false
    },
    async tryToSave() {
      const body = {
        ownerId: this.ownerId,
        status: this.stepStatus,
        comment: this.localComment
      }
      await execHttpRequestThrowable(async () => await this.saver(body),
      {},
      v => this.loading = v)

      this.$snackbar.success("snackbar.success.approvalCommentSaved")
      this.$emit("success", body)
    }
  },
  mounted() {
    this.localComment = this.comment
  }
}
</script>
<style>

</style>